export default function Challenges() {
  const challenges = [
    {
      icon: 'ri-time-line',
      emoji: '⚖️',
      title: 'Downtime That Costs Real Money',
      description: 'When email is down, documents won\'t open, or systems run slow, attorneys can\'t bill. Lost productivity quickly turns into lost revenue.',
      solution: 'We prevent outages before they happen and respond fast when they do.'
    },
    {
      icon: 'ri-shield-keyhole-line',
      emoji: '🔐',
      title: 'Client Confidentiality & Compliance Pressure',
      description: 'Law firms handle highly sensitive data and are held to strict ethical and regulatory standards. One breach or misstep can damage your firm\'s reputation.',
      solution: 'We help align your IT with legal compliance requirements and best practices.'
    },
    {
      icon: 'ri-user-settings-line',
      emoji: '👥',
      title: 'Risky Onboarding & Offboarding',
      description: 'New hires need access on Day One. Departing employees must be fully removed—immediately. Gaps here create major security and compliance risks.',
      solution: 'We automate and document secure onboarding and offboarding processes.'
    },
    {
      icon: 'ri-customer-service-2-line',
      emoji: '⏱️',
      title: 'Slow IT Response Times',
      description: 'Attorneys don\'t want to wait hours—or days—for help. They need issues resolved quickly so they can stay focused on clients and cases.',
      solution: 'We provide fast response times with clear SLAs and priority handling for legal teams.'
    },
    {
      icon: 'ri-cloud-line',
      emoji: '🏛️',
      title: 'Secure Remote & Hybrid Work',
      description: 'Court appearances, remote hearings, and after-hours work require secure access from anywhere—without exposing client data.',
      solution: 'We deliver secure remote access, device management, and zero-trust security models.'
    }
  ];

  return (
    <section id="challenges" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center mb-4">
            <i className="ri-error-warning-line text-[#e10708] text-xl mr-2 w-5 h-5 flex items-center justify-center"></i>
            <span className="text-[#e10708] text-sm uppercase tracking-widest font-light">Daily Challenges</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif text-[#1A1F2E] leading-tight mb-6">
            The IT Challenges Law Firms<br />Face Every Day
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We understand the unique technology pressures that impact your firm's productivity, security, and reputation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {challenges.map((challenge, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 border border-gray-200 hover:border-[#e10708] transition-all duration-300 hover:shadow-xl hover:shadow-[#e10708]/10"
            >
              <div className="text-4xl mb-4">{challenge.emoji}</div>
              
              <h3 className="text-xl font-bold text-[#1A1F2E] mb-4">
                {challenge.title}
              </h3>

              <p className="text-gray-600 text-base leading-relaxed mb-6">
                {challenge.description}
              </p>

              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm font-semibold text-[#e10708] mb-2">Our Solution:</p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  {challenge.solution}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
